import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaPlus, FaCheck, FaTimes, FaEdit, FaTrashAlt } from 'react-icons/fa';
import Swal from 'sweetalert2';

const PageContainer = styled.div`
  padding: 40px;
  min-height: 100vh;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const AddButton = styled.button`
  background: #34574A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #27443a;
  }
`;

const TableWrapper = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;

  th, td {
    padding: 16px 12px;
    text-align: left;
    font-size: 0.95rem;
    border-bottom: 1px solid #eee;
    vertical-align: top;
  }

  th {
    background: #f8f9fa;
    color: #666;
    font-weight: 600;
    text-transform: uppercase;
  }

  tr:hover {
    background: #f8f9fa;
  }
`;

const StatusButton = styled.button`
  background: ${props => props.$ativo ? '#22c55e' : '#c62828'};
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 4px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.2s;
  &:hover {
    opacity: 0.8;
  }
`;

const ActionCell = styled.td`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  color: #c0843d;
  font-size: 1.1rem;
  transition: background 0.2s;
  &:hover {
    background: #f8f8f8;
    color: #c62828;
  }
`;

const TipoPlanoForm = ({ onSubmit, onCancel, initialData }) => {
  const [plano, setPlano] = useState(initialData?.planoTIPOPLANO || '');
  const [slug, setSlug] = useState(initialData?.slugTIPOPLANO || '');
  const [order, setOrder] = useState(initialData?.orderTIPOPLANO || 0);
  const [periodo, setPeriodo] = useState(initialData?.periodoTIPOPLANO || 0);
  const [ativo, setAtivo] = useState(initialData?.ativoTIPOPLANO !== 0);

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit({ plano, slug, order, periodo, ativo });
  };

  return (
    <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:18,minWidth:340}}>
      <div style={{display:'flex',flexDirection:'column',gap:6}}>
        <label style={{fontWeight:600,color:'#34574A'}}>Nome do Tipo</label>
        <input value={plano} onChange={e=>setPlano(e.target.value)} required style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,fontSize:'1rem'}} />
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:6}}>
        <label style={{fontWeight:600,color:'#34574A'}}>Slug</label>
        <input value={slug} onChange={e=>setSlug(e.target.value)} required style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,fontSize:'1rem'}} />
      </div>
      <div style={{display:'flex',gap:12}}>
        <div style={{flex:1,display:'flex',flexDirection:'column',gap:6}}>
          <label style={{fontWeight:600,color:'#34574A'}}>Ordem</label>
          <input type="number" value={order} onChange={e=>setOrder(e.target.value)} required style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,fontSize:'1rem'}} />
        </div>
        <div style={{flex:1,display:'flex',flexDirection:'column',gap:6}}>
          <label style={{fontWeight:600,color:'#34574A'}}>Período</label>
          <input type="number" value={periodo} onChange={e=>setPeriodo(e.target.value)} required style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:6,fontSize:'1rem'}} />
        </div>
      </div>
      <div style={{display:'flex',alignItems:'center',gap:12}}>
        <label style={{fontWeight:600,color:'#34574A'}}>Status</label>
        <StatusButton type="button" $ativo={ativo} onClick={()=>setAtivo(true)}>Ativo</StatusButton>
        <StatusButton type="button" $ativo={!ativo} onClick={()=>setAtivo(false)}>Inativo</StatusButton>
      </div>
      <div style={{display:'flex',justifyContent:'flex-end',gap:12}}>
        <button type="button" style={{background:'#bbb',color:'#222',border:'none',borderRadius:8,padding:'10px 18px',fontSize:'1rem',fontWeight:600,cursor:'pointer'}} onClick={onCancel}>Cancelar</button>
        <button type="submit" style={{background:'#34574A',color:'#fff',border:'none',borderRadius:8,padding:'10px 18px',fontSize:'1rem',fontWeight:600,cursor:'pointer'}}>Salvar</button>
      </div>
    </form>
  );
};

const TiposPlanos = () => {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [pagina, setPagina] = useState(1);
  const porPagina = 7;
  const totalPaginas = Math.ceil(tipos.length / porPagina);
  const paginados = tipos.slice((pagina - 1) * porPagina, pagina * porPagina);

  const fetchTipos = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem('auth_token');
    try {
      const res = await fetch(`${import.meta.env.VITE_URL_API}/tipos-planos`, {
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      setTipos(Array.isArray(data) ? data : []);
    } catch {
      setError('Erro ao buscar tipos de planos.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTipos();
  }, []);

  const handleAdd = () => {
    setEditData(null);
    setShowForm(true);
  };

  const handleEdit = (item) => {
    setEditData(item);
    setShowForm(true);
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditData(null);
  };

  const handleFormSubmit = async (formData) => {
    const token = localStorage.getItem('auth_token');
    if (!token) return;
    try {
      if (editData) {
        const res = await fetch(`${import.meta.env.VITE_URL_API}/tipos-planos/${editData.codigoTIPOPLANO}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            planoTIPOPLANO: formData.plano,
            slugTIPOPLANO: formData.slug,
            orderTIPOPLANO: parseInt(formData.order),
            periodoTIPOPLANO: parseInt(formData.periodo),
            ativoTIPOPLANO: formData.ativo ? 1 : 0
          })
        });
        if (!res.ok) {
          throw new Error('Falha ao atualizar o tipo de plano.');
        }
        Swal.fire('Sucesso', 'Tipo de plano atualizado com sucesso!', 'success');
      } else {
        const res = await fetch(`${import.meta.env.VITE_URL_API}/tipos-planos`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            planoTIPOPLANO: formData.plano,
            slugTIPOPLANO: formData.slug,
            orderTIPOPLANO: parseInt(formData.order),
            periodoTIPOPLANO: parseInt(formData.periodo),
            ativoTIPOPLANO: formData.ativo ? 1 : 0
          })
        });
        if (!res.ok) {
          throw new Error('Falha ao criar o tipo de plano.');
        }
        Swal.fire('Sucesso', 'Tipo de plano criado com sucesso!', 'success');
      }
      setShowForm(false);
      setEditData(null);
      fetchTipos();
    } catch {
      Swal.fire('Erro', 'Não foi possível salvar o tipo de plano.', 'error');
    }
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: 'Tem certeza?',
      text: `Deseja realmente excluir o tipo de plano "${item.planoTIPOPLANO}"? Esta ação não poderá ser desfeita!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c62828',
      cancelButtonColor: '#34574A',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem('auth_token');
        if (!token) return;
        try {
          await fetch(`${import.meta.env.VITE_URL_API}/tipos-planos/${item.codigoTIPOPLANO}`, {
            method: 'DELETE',
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });
          setTimeout(fetchTipos, 400);
          Swal.fire('Sucesso', 'Tipo de plano excluído com sucesso!', 'success');
        } catch {
          Swal.fire('Erro', 'Não foi possível excluir o tipo de plano.', 'error');
        }
      }
    });
  };

  return (
    <PageContainer style={{ background: '#f5f5f5' }}>
      <HeaderRow>
        <h1 style={{margin:0}}>Tipos de Planos</h1>
        <AddButton onClick={handleAdd}><FaPlus /> Novo Tipo</AddButton>
      </HeaderRow>
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>Slug</th>
              <th>Ordem</th>
              <th>Período</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {paginados.map(item => (
              <tr key={item.codigoTIPOPLANO}>
                <td>{item.codigoTIPOPLANO}</td>
                <td>{item.planoTIPOPLANO}</td>
                <td>{item.slugTIPOPLANO}</td>
                <td>{item.orderTIPOPLANO}</td>
                <td>{item.periodoTIPOPLANO}</td>
                <td>
                  <StatusButton
                    $ativo={item.ativoTIPOPLANO === 1}
                    onClick={async () => {
                      const token = localStorage.getItem('auth_token');
                      if (!token) return;
                      try {
                        const res = await fetch(`${import.meta.env.VITE_URL_API}/tipos-planos/${item.codigoTIPOPLANO}`, {
                          method: 'PUT',
                          headers: {
                            'accept': 'application/json',
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({
                            ativoTIPOPLANO: item.ativoTIPOPLANO === 1 ? 0 : 1
                          })
                        });
                        if (!res.ok) throw new Error();
                        setTimeout(fetchTipos, 400);
                      } catch {
                        Swal.fire('Erro', 'Não foi possível atualizar o status.', 'error');
                      }
                    }}
                    title={item.ativoTIPOPLANO === 1 ? 'Desativar' : 'Ativar'}
                  >
                    {item.ativoTIPOPLANO === 1 ? <FaCheck /> : <FaTimes />} {item.ativoTIPOPLANO === 1 ? 'Ativo' : 'Inativo'}
                  </StatusButton>
                </td>
                <ActionCell>
                  <IconButton title="Editar" onClick={()=>handleEdit(item)}><FaEdit /></IconButton>
                  <IconButton title="Excluir" onClick={()=>handleDelete(item)}><FaTrashAlt /></IconButton>
                </ActionCell>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* Paginação */}
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:8,margin:'24px 0'}}>
          <button onClick={()=>setPagina(p=>Math.max(1,p-1))} disabled={pagina===1} style={{padding:'6px 14px',borderRadius:6,border:'1px solid #eee',background:'#fff',cursor:pagina===1?'not-allowed':'pointer'}}>Anterior</button>
          {[...Array(totalPaginas)].map((_,i)=>(
            <button
              key={i}
              onClick={()=>setPagina(i+1)}
              style={{padding:'6px 12px',borderRadius:6,border:'1.5px solid '+(pagina===i+1?'#34574A':'#eee'),background:pagina===i+1?'#34574A':'#fff',color:pagina===i+1?'#fff':'#222',fontWeight:600,cursor:'pointer'}}
            >{i+1}</button>
          ))}
          <button onClick={()=>setPagina(p=>Math.min(totalPaginas,p+1))} disabled={pagina===totalPaginas} style={{padding:'6px 14px',borderRadius:6,border:'1px solid #eee',background:'#fff',cursor:pagina===totalPaginas?'not-allowed':'pointer'}}>Próxima</button>
        </div>
        {showForm && (
          <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.25)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div style={{background:'#fff',padding:32,borderRadius:12,minWidth:360}}>
              <h2 style={{marginBottom:16}}>{editData ? 'Editar Tipo de Plano' : 'Novo Tipo de Plano'}</h2>
              <TipoPlanoForm onSubmit={handleFormSubmit} onCancel={handleFormCancel} initialData={editData} />
            </div>
          </div>
        )}
      </TableWrapper>
    </PageContainer>
  );
};

export default TiposPlanos;
